import { BookingListResponseData } from '../../types';

export const getBookingCountLabel = (data?: BookingListResponseData) => {
  let totalOfBookings = 0;
  if (data && data.bookingList && data.bookingList.bookings) {
    totalOfBookings = data.bookingList.bookings.length;
  }
  return `${totalOfBookings} booking${totalOfBookings === 1 ? '' : 's'} found`;
};
